/**
 * @generated SignedSource<<bc79ec9d901c9b39254354c88f171cd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type bambooDuplicates_viewer$data = {
  readonly id: string;
  readonly missionControlData: {
    readonly id: string;
    readonly bambooDuplicates: ReadonlyArray<{
      readonly id: string;
      readonly company: string | null;
      readonly duplicateCount: number | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "bambooDuplicates_viewer";
};
export type bambooDuplicates_viewer$key = {
  readonly " $data"?: bambooDuplicates_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"bambooDuplicates_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "bambooDuplicates_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlBambooDuplicatesType",
          "kind": "LinkedField",
          "name": "bambooDuplicates",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duplicateCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "faa0f0973cf1c0249cb4d18667c88ebf";

export default node;
